import React from 'react';
import { Link } from 'react-router-dom';
import { DotLoading } from 'antd-mobile';
import styles from './BindingPage.module.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';

export default function Loading() {
  return (
    <div className="center-viewport">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
          <div className={styles['center-card']} style={{alignItems: 'center', justifyContent: 'center', minHeight: 220}}>
            <div style={{ marginBottom: 16 }}>
              <DotLoading color='#EB0A1E' style={{ fontSize: 48 }} />
            </div>
            <div className={styles['status-title']} style={{ marginBottom: 0 }}>系統執行中...</div>
            <div className={styles['status-desc']} style={{ marginTop: 0 }}>請稍候</div>
          </div>
    </div>
  );
} 